export default __webpack_public_path__ + "static/artobg-cbd7d847be309acf43bc734a53d2b5a6.png";